export const messages = {
  en: {
    itemReleaseUndo: {
      title: 'Release Pending Orders',
      back: 'Back',
      refresh: 'Refresh',
      orderNo: 'Order No',
      releaseType: 'Release Type',
      applyUnit: 'Applicant Unit',
      applicant: 'Applicant',
      idCard: 'ID Card',
      phone: 'Phone',
      passTime: 'Pass Time',
      items: 'Items',
      viewItems: 'View Items',
      status: 'Status',
      plateNo: 'Plate No',
      none: 'None',
      operations: 'Operations',
      process: 'Process',
      detail: 'Detail'
    },
    processReleaseUndo: {
      title: 'Release Pending Orders',
      submit: 'Submit',
      success: 'Submit successful',
      failed: 'Submit failed'
    }
  },
  zh: {
    itemReleaseUndo: {
      title: '放行待办单',
      back: '返回',
      refresh: '刷新',
      orderNo: '单号',
      releaseType: '放行类型',
      applyUnit: '申请单位',
      applicant: '申请人',
      idCard: '身份证',
      phone: '手机号',
      passTime: '通行时间',
      items: '物品',
      viewItems: '查看物品',
      status: '状态',
      plateNo: '车牌号',
      none: '无',
      operations: '操作',
      process: '办理',
      detail: '详情'
    },
    processReleaseUndo: {
      title: '放行待办单',
      submit: '提交',
      success: '提交成功',
      failed: '提交失败'
    }
  },
  'zh-TW': {
    itemReleaseUndo: {
      title: '放行待辦單',
      back: '返回',
      refresh: '刷新',
      orderNo: '單號',
      releaseType: '放行類型',
      applyUnit: '申請單位',
      applicant: '申請人',
      idCard: '身份證',
      phone: '手機號',
      passTime: '通行時間',
      items: '物品',
      viewItems: '查看物品',
      status: '狀態',
      plateNo: '車牌號',
      none: '無',
      operations: '操作',
      process: '辦理',
      detail: '詳情'
    },
    processReleaseUndo: {
      title: '放行待辦單',
      submit: '提交',
      success: '提交成功',
      failed: '提交失敗'
    }
  }
}
